<div class="sb-step sb-step-summary">
  <form class="sb-step__form" [formGroup]="formGroup">
    <section class="sb-step__form__content">
      <div class="sb-step__inner-container">
        <div class="sb-summary-block__title">
          {{'STEP.SUMMARY.TITLE' | translate}}
        </div>
        <sb-box-info [iconType]="['ico-info']" [infoText]="'STEP.SUMMARY.INFO' | translate"></sb-box-info>
<!-- SEZIONE DATI PERSONALI E CONTATTI -->
        <ng-container>
          <div class="step-summary__block">
            <div class="step-summary__block__title">
              Tipologia SIM
            </div>
            <div class="step-summary__block__descrow">
              {{inferSimType(simType)}}
            </div>
          </div>

          <div class="step-summary__block">
            <div class="step-summary__block__title">
              <div>{{'STEP.SUMMARY.PERSONAL-DATA' | translate}}</div>
              <div>
                <a class="wt-link wt-text-base-m" (click)="navigateTo(StepId.Customer)">
                  <img src="assets/images/icon-summary-edit.svg" alt="Modifica" class="edit-summary">
                </a>
              </div>
            </div>
            <div class="step-summary__block__descrow">
              {{'ENTITY.CUSTOMER-IDENTITY.NAME' | translate}}: {{customerName}}
            </div>
            <div class="step-summary__block__descrow">
              {{'ENTITY.CUSTOMER-IDENTITY.SURNAME' | translate}}: {{customerLastName}}
            </div>
            <div class="step-summary__block__descrow">
              {{'ENTITY.CUSTOMER-IDENTITY.FISCAL-CODE' | translate}}: {{taxCode}}
            </div>
          </div>

          <div class="step-summary__block">
            <div class="step-summary__block__title">
              <div>{{'STEP.SUMMARY.CONTACTS' | translate}}</div>
              <div>
                <a class="wt-link wt-text-base-m" (click)="navigateTo(StepId.Contacts)">
                  <img src="assets/images/icon-summary-edit.svg" alt="Modifica" class="edit-summary">
                </a>
              </div>
            </div>
            <div class="step-summary__block__descrow">
              {{'ENTITY.CONTACTS.EMAIL' | translate}}: {{email}}
            </div>
            <div class="step-summary__block__descrow">
              {{'ENTITY.CONTACTS.PHONE-NUMBER' | translate}}: {{mobileNumber}}
            </div>
          </div>
        </ng-container>
<!-- FINE SEZIONE DATI PERSONALI E CONTATTI -->

<!-- SEZIONE SPEDIZIONE -->
        <ng-container>
          <div class="step-summary__block">
            <div class="step-summary__block__title">
              <div>{{((simType === SIM_TYPES.IdleSim || simType === SIM_TYPES.eSim) ? 'STEP.SUMMARY.RESIDENCE-ADDRESS' : 'STEP.SUMMARY.DELIVERY-ADDRESS') | translate}}</div>
              <div>
                <a class="wt-link wt-text-base-m" (click)="navigateTo(StepId.Address)">
                  <img src="assets/images/icon-summary-edit.svg" alt="Modifica" class="edit-summary">
                </a>
              </div>
            </div>
            <ng-container *ngIf="simType === SIM_TYPES.IdleSim || simType === SIM_TYPES.eSim">
              <div class="step-summary__block__descrow" *ngIf="deliveryInfoRecipientStreet != residenceInfoRecipientStreet">
                {{'ENTITY.DELIVERY-ADDRESS.RECIPIENT' | translate}}: {{residenceInfoRecipientStreet}}, {{residenceInfoRecipientNumber}} - {{residenceInfoRecipientCity}}, {{residenceInfoRecipientCountry}}
              </div>
            </ng-container>
            <ng-container *ngIf="simType === SIM_TYPES.Standard">
              <div class="step-summary__block__descrow">
                {{deliveryInfoRecipientStreet | titlecase}}, {{deliveryInfoRecipientNumber}}
              </div>
              <div class="step-summary__block__descrow">
                {{'ENTITY.DELIVERY-ADDRESS.CITY' | translate}}: {{deliveryInfoRecipientCity}}
              </div>
              <div class="step-summary__block__descrow">
                {{'ENTITY.DELIVERY-ADDRESS.DISTRICT' | translate}}: {{deliveryInfoRecipientDistrict}}
              </div>
              <div class="step-summary__block__descrow" *ngIf="deliveryInfoRecipientStreet != residenceInfoRecipientStreet">
                {{'ENTITY.DELIVERY-ADDRESS.RECIPIENT' | translate}}: {{residenceInfoRecipientStreet | titlecase}}, {{residenceInfoRecipientNumber}} - {{residenceInfoRecipientCity}}, {{residenceInfoRecipientCountry}}
              </div>
              <div class="step-summary__block__reseqdel" *ngIf="deliveryInfoRecipientStreet == residenceInfoRecipientStreet">
                <img src="assets/images/ico-info.svg" alt="ico-info" class="step-summary__block__reseqdel__icon"> {{'STEP.SUMMARY.INFO-DELIVERY' | translate}}
              </div>
            </ng-container>
          </div>
        </ng-container>
<!-- FINE SEZIONE SPEDIZIONE -->

<!-- SEZIONE PORTABILITÀ -->
        <ng-container *ngIf="mnpMsisdn">
          <div class="step-summary__block">
            <div class="step-summary__block__title">
              <div>{{'STEP.SUMMARY.PORTABILITY' | translate}}</div>
              <div>
                <a class="wt-link wt-text-base-m" (click)="navigateTo(StepId.ActivationOtp)">
                  <img src="assets/images/icon-summary-edit.svg" alt="Modifica" class="edit-summary">
                </a>
              </div>
            </div>
            <div class="step-summary__block__descrow">
              {{'STEP.SUMMARY.PORTABILITY-NUMBER' | translate}}: {{mnpMsisdn}}
            </div>
            <div class="step-summary__block__descrow">
              {{'STEP.SUMMARY.PORTABILITY-OPERATOR' | translate}}: {{inferMnpOperators(mnpOperator)}}
            </div>
          </div>
        </ng-container>
<!-- FINE PORTABILITÀ -->

<!-- SEZIONE RICARICA AUTOMATICA -->
        <ng-container *ngIf="isSmartTopUpEnabled && !isSmartTopUpMandatory || selectedAddons">
          <div class="step-summary__block">
            <div class="step-summary__block__title">
              <div>{{'STEP.SUMMARY.OFFER-EXTRAS' | translate}}</div>
              <div>
                <a class="wt-link wt-text-base-m" (click)="navigateTo(StepId.OfferExtras)">
                  <img src="assets/images/icon-summary-edit.svg" alt="Modifica" class="edit-summary">
                </a>
              </div>
            </div>
            <div class="step-summary__block__descrow__offer-extras-item" *ngIf="!isSmartTopUpMandatory">
              <p class="option">Ricarica automatica</p>
              Status: {{ ('STEP.SUMMARY.SMART-TOP-UP-' + (offerExtras?.smartTopUp ? 'ACTIVE' : 'INACTIVE')) | translate}}
            </div>
            <div class="addon-single" *ngIf="selectedAddons">
              <div class="step-summary__block__descrow__offer-extras-item" *ngFor="let addon of selectedAddons">
                <p class="option">{{inferActiveAddons(addon)}}</p>
                Status: {{ 'STEP.SUMMARY.SMART-TOP-UP-ACTIVE' | translate}}
              </div>
            </div>
          </div>
        </ng-container>
<!-- FINE RICARICA AUTOMATICA -->

<!-- SEZIONE CODICE PROMOZIONALE -->
        <ng-container *ngIf="mgmCode || couponCode">
          <div class="step-summary__block">
            <div class="step-summary__block__title">
              <div>{{'STEP.SUMMARY.PROMO-CODE' | translate}}</div>
              <div>
                <a class="wt-link wt-text-base-m" (click)="navigateTo(StepId.OfferExtras)">
                  <img src="assets/images/icon-summary-edit.svg" alt="Modifica" class="edit-summary">
                </a>
              </div>
            </div>
            <div class="step-summary__block__descrow" *ngIf="mgmCode">
              {{ 'STEP.SUMMARY.PROMO-CODE-FRIEND-CODE' | translate }}
              {{ 'STEP.SUMMARY.PROMO-CODE-ACTIVE' | translate}}
            </div>
            <div class="step-summary__block__descrow" *ngIf="couponCode">
              {{ 'STEP.SUMMARY.PROMO-CODE-COUPON' | translate }}
              {{ 'STEP.SUMMARY.PROMO-CODE-ACTIVE' | translate }}
            </div>
          </div>
        </ng-container>
<!-- FINE CODICE PROMOZIONALE -->

      </div>
    </section>
    <div class="sb-step__form__footer">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </div>
  </form>
</div>
